module.exports = __webpack_public_path__ + "static/media/onboarding-profile-image.c659d049.png";